import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBodyListado, IDocentesID, IListaReportes, IReporte, IResOrigen, ISedes } from 'src/app/interfaces/auditoria';
import { ISeccion } from 'src/app/interfaces/exclusion-asignatura';
import { IListaAnhos, IListaAsignaturas, IListaPeriodos } from 'src/app/interfaces/ponderaciones';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditoriaService {

  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getFiltrosAnhos(): Observable<IListaAnhos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }

  getFiltrosPeriodos(anho: number): Observable<IListaPeriodos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-periodos?anyo=${anho}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }
  getFiltrosSedes(userId: number): Observable<ISedes> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes?usuario-id=${userId}`
    return this.http.get<ISedes>(url, { headers: this.getHeaders() })
  }

  getFiltrosAsignaturas(anyo:number, periodoId: number, sedeId: number): Observable<IListaAsignaturas> {

    let url = "";
    if(sedeId == 0) {
      url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/buscar-asignatura?anyo=${anyo}&periodo-id=${periodoId}`
    } else {
      url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/buscar-asignatura?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}`
    }
    return this.http.get<IListaAsignaturas>(url, { headers: this.getHeaders() })
  }
  getFiltrosSeccion(body: any): Observable<ISeccion> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/buscar-secciones?anyo=${body.anyo}&periodo-id=${body.periodoId}&sede-id=${body.sedeId}`
    return this.http.get<ISeccion>(url, {headers: this.getHeaders()});
  }

  getFiltrosIdDocente( body: any): Observable<IDocentesID> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/obtener-docentes-filtros?anyo=${body.anyo}&periodo-id=${body.periodoId}&asignatura-id=${body.asignaturaId}&sede-id=${body.sedeId}&seccion-id=${body.seccionId}`
    return this.http.get<IDocentesID>(url, {headers: this.getHeaders()});
  }

  getListadoReportes( body: IBodyListado):  Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/buscaListadoReportes`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  generarSolicitudReporte( body: IBodyListado): Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/generaSolicitudReporte`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  obtenerReporte(idSolicitud: number):Observable<IReporte> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/obtener-reporte?idSolicitudReporte=${idSolicitud}`
    return this.http.get<IReporte>(url, {headers: this.getHeaders()});
  }

  getReporte(reporteId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/obtener-reporte-bytes?idSolicitudReporte=${reporteId}`;
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }

  getOrigenes():  Observable<IResOrigen> {
    const url = `${environment.endpointAdministrativo}/v1/auditoria/obtener-origenes`
    return this.http.get<IResOrigen>(url, { headers: this.getHeaders() });
  }

}
